// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"tags-module--tagsList--39vLn","bannerImgContainer":"tags-module--bannerImgContainer--24LjU","bannerImg":"tags-module--bannerImg--xzH6c"};